// typescript
import api from './api';

export const getListInsurence = async () => {
  interface TypeSelectData {
    _id: string;
    name: string;
  }

  const names: string[] = [
    'ALFA SEGURADORA S.A.',
    'ALIANÇA DO BRASIL SEGUROS S.A',
    'ALLIANZ DO BRASIL',
    'AMERICAN LIFE COMPANHIA DE SEGUROS',
    'ANGELS SEGUROS',
    'ANGELUS SEGUROS S/A.',
    'ARUANA SEGURADORA S. A.',
    'ASSOCIAÇÃO',
    'ASSURANT SEGURADORA SA',
    'ATLÂNTICA COMPANHIA DE SEGUROS',
    'AUSTRAL SEGURADORA S/A',
    'AXA SEGUROS',
    'AZUL COMPANHIA DE SEGUROS GERAIS',
    'BANESTES SEGUROS S/A',
    'BANSEG',
    'BMG SEGUROS SA',
    'BRADESCO AUTO/RE COMPANHIA DE SEGUROS',
    'BRASILSEG COMPANHIA DE SEGUROS',
    'CAIXA SEGURADORA S/A',
    'CAPEMISA SEGURADORA DE VIDA E PREVIDÊNCIA S/A',
    'CENTAURO VIDA E PREVIDÊNCIA S. A.',
    'CESCEBRASIL SEGUROS DE GARANTIAS E CRÉDITO S.A.',
    'CHUBB',
    'CIA SEGUROS PREVIDENCIA DO SUL',
    'CLUBE PRO+ ASSOCIAÇÃO',
    'COMPANHIA DE SEGUROS ALIANÇA DA BAHIA',
    'COMPANHIA EXCELSIOR DE SEGUROS',
    'COMPREV SEGURADORA S/A',
    'COMPREV VIDA E PREVIDÊNCIA S.A.',
    'CONFIAUTO',
    'DARWIN SEGUROS',
    'DAYPREV VIDA E PREVIDÊNCIA S.A.',
    'ESSOR SEGUROS S.A',
    'EZZE SEGUROS',
    'FATOR SEGURADORA S/A',
    'GAZIN SEGUROS S.A.',
    'GENTE SEGURADORA S.A.',
    'HDI SEGUROS',
    'ICATU SEGUROS',
    'INVESTPREV SEGURADORA S.A',
    'INVESTPREV SEGUROS E PREVIDÊNCIA S/A',
    'ITAU SEGUROS DE AUTO E RES_idÊNCIA',
    'LIBERTY SEGUROS',
    'LOOVI',
    'LUIZ SEG',
    'MAPFRE PREVIDÊNCIA S.A.',
    'MAPFRE SEGUROS GERAIS S.A.',
    'MAPFRE VIDA S.A.',
    'MASTER AUTO & TRUCK',
    'MBM SEGURADORA S/A',
    'MG SEGUROS VIDA E PREVIDÊNCIA SA',
    'MITISUI',
    'MONGERAL AEGON SEGUROS E PREVIDÊNCIA S. A.',
    'MULTIPLUS',
    'NOBRE',
    'NOVO SEGUROS',
    'OMINT SEGUROS SA',
    'PORTO SEGURO CIA DE SEGUROS GERAIS',
    'PORTO SEGURO VIDA E PREVIDÊNCIA S.A.',
    'POTTENCIAL SEGURADORA SA',
    'PREVIMAX PREVIDENCIA PRIVADA E SEGURADORA S/A',
    'PREVIMIL VIDA E PREVIDÊNCIA S.A.',
    'SABEMI SEGURADORA SA',
    'SAFRA SEGUROS GERAIS S.A.',
    'SAFRA VIDA E PREVIDÊNCIA S.A.',
    'SANCOR SEGUROS DO BRASIL S.A.',
    'SEGURADORA LÍDER DO CONSÓRCIO DO SEGURO DPVAT S.A.',
    'SELF PROTEÇÃO VEICULAR',
    'SINAF PREVIDENCIAL CIA DE SEGUROS',
    'SOMPO SEGUROS S.A.',
    'STARR INTERNATIONAL BRASIL SEGURADORA S.A.',
    'SUHAI SEGURADORA SA',
    'TOKIO MARINE SEGURADORA S.A.',
    'TOO SEGUROS',
    'UB PROTEÇÃO VEICULAR',
    'UNIÃO SEGURADORA S/A - VIDA E PREVIDÊNCIA',
    'USEBENS SEGUROS S/A',
    'XPRESS PROTEÇÃO VEICULAR',
    'YELUM',
    'YOUSE SEGUROS',
    'ZURICH SEGUROS',
  ];

  const seen = new Set<string>();
  const unique: TypeSelectData[] = [];

  for (const raw of names) {
    const key = raw.replace(/\s+/g, ' ').trim().toUpperCase();
    if (seen.has(key)) continue;
    seen.add(key);
    unique.push({ _id: raw, name: raw });
  }

  return unique;
};
